/**
 * Engine team → art affiliation key (rim bake / tint).
 * Pack affiliation.json stays Data; this only maps team ids to keys.
 */

/** Binary Frontline / Dropfront style: 0=ally, 1=enemy. */
export function affiliationForBinaryTeam(
  team: number,
): "ally" | "enemy" {
  return team === 1 ? "enemy" : "ally";
}

/**
 * Lookup map (e.g. FFA multi-enemy). Falls back to ally.
 */
export function affiliationFromTeamMap(
  teamId: number,
  map: Readonly<Record<number, string>>,
  fallback = "ally",
): string {
  return map[teamId] ?? fallback;
}
